import axios from "axios";

const DEFAULT_CONF = {};

const OQFilesApi = {
  startFileUploading(file) {
    return axios
      .post(
        process.env.VUE_APP_OQ_FILE_API + "/start_uploading",
        { file },
        DEFAULT_CONF
      )
      .then((r) => {
        return r.data.file_id;
      })
      .catch(() => undefined);
  },
  // eslint-disable-next-line no-unused-vars
  uploadFileChunk(file_id, chunk, offset, size) {
    return axios
      .post(
        process.env.VUE_APP_OQ_FILE_API + "/upload_chunk",
        { file_id, chunk: btoa(chunk), offset, size },
        { ...DEFAULT_CONF }
      )
      .then((r) => {
        return r.data;
      })
      .catch(() => undefined);
  },
  getFileInfo(file_id) {
    return axios
      .post(
        process.env.VUE_APP_OQ_FILE_API + "/file_info",
        { file_id },
        DEFAULT_CONF
      )
      .then((r) => {
        return r.data;
      })
      .catch(() => undefined);
  },
};

export default OQFilesApi;
